import React from "react";
import Select from "react-select";

const CustomDropdown = ({
  fieldName,
  error,
  values,
  label,
  classes,
  setFieldValue,
  options,
  handleChange,
}) => {
  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-3 ${error ? "is-invalid" : "is-valid"
        }`}
    >
      <label className="text-label">{label}</label>
      <Select
        value={{
          label: values.label,
          value: values.value,
        }}
        onChange={(selectedOption) => {
          setFieldValue(fieldName, selectedOption.value);
          if (handleChange) {
            handleChange(selectedOption);
          }
        }}
        onBlur={() => setFieldValue(`touched.${fieldName}`, true)}
        options={options}
        name={fieldName}
        style={{
          color: "#7e7e7e",
          paddingLeft: " 15px",
        }}
        classNames={{
          control: (state) => "form-control p-0 select-custom-css", // add your class here
        }}
      />

      {error && (
        <div
          id={`val-${fieldName}-error`}
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
